/**
 * Generated by orval v8.18.0 🍺
 * Do not edit manually.
 * LiftAI API
 * LiftAI elevator/lift asset-management REST API.
 * OpenAPI spec version: 1.0.0 (v1)
 */
import * as zod from 'zod';


/**
 * Adds a GET-only ``aggregate`` action to a viewset.
 *
 * The viewset must declare ``AGGREGATE_CONFIG: AggregateConfig`` and a
 * ``filterset_class``. GET-only because the chat loopback only issues GET.
 */
export const PropertiesListQueryParams = zod.object({
  "address": zod.string().optional(),
  "client_id": zod.string().optional(),
  "ordering": zod.array(zod.enum(['-name', 'name'])).optional().describe('Ordering\n\n\* `name` - Name\n\* `-name` - Name (descending)'),
  "portfolio": zod.array(zod.string().uuid()).optional(),
  "query": zod.string().optional(),
  "region": zod.array(zod.string().nullable()).optional()
})

export const propertiesListResponseAddressOneRawMax = 200;

export const propertiesListResponseAddressOneFormattedMax = 200;

export const propertiesListResponseAddressOneStreetNumberMax = 20;

export const propertiesListResponseRegionMax = 255;

export const propertiesListResponseClientIdMax = 255;

export const propertiesListResponseLatDefault = 0;
export const propertiesListResponseLngDefault = 0;
export const propertiesListResponsePropertyManagerOneOwnerOneUsernameMax = 150;


export const propertiesListResponsePropertyManagerOneOwnerOneUsernameRegExp = new RegExp('^[\\w.@+-]+$');
export const propertiesListResponsePropertyManagerOneOwnerOneEmailMax = 254;

export const propertiesListResponsePropertyManagerOneOwnerOnePhoneNumberMax = 128;

export const propertiesListResponseConsultantGroupOneOwnerOneUsernameMax = 150;


export const propertiesListResponseConsultantGroupOneOwnerOneUsernameRegExp = new RegExp('^[\\w.@+-]+$');
export const propertiesListResponseConsultantGroupOneOwnerOneEmailMax = 254;

export const propertiesListResponseConsultantGroupOneOwnerOnePhoneNumberMax = 128;

export const propertiesListResponseConsultantGroupOneConsultantsItemUsernameMax = 150;


export const propertiesListResponseConsultantGroupOneConsultantsItemUsernameRegExp = new RegExp('^[\\w.@+-]+$');
export const propertiesListResponseConsultantGroupOneConsultantsItemEmailMax = 254;

export const propertiesListResponseConsultantGroupOneConsultantsItemPhoneNumberMax = 128;

export const propertiesListResponseConsultantGroupOneFileRegExp = new RegExp('(?:jpg|png|jpeg)$');
export const propertiesListResponseAssignedConsultantOneUsernameMax = 150;


export const propertiesListResponseAssignedConsultantOneUsernameRegExp = new RegExp('^[\\w.@+-]+$');
export const propertiesListResponseAssignedConsultantOneEmailMax = 254;

export const propertiesListResponseAssignedConsultantOnePhoneNumberMax = 128;

export const propertiesListResponseBuildingNumberMax = 255;

export const propertiesListResponseContactOneNameMax = 255;



export const PropertiesListResponseItem = zod.object({
  "id": zod.string().uuid(),
  "createdAt": zod.string().datetime({"offset":true}),
  "updatedAt": zod.string().datetime({"offset":true}).nullable(),
  "name": zod.string(),
  "address": zod.object({
  "id": zod.number(),
  "raw": zod.string().max(propertiesListResponseAddressOneRawMax),
  "formatted": zod.string().max(propertiesListResponseAddressOneFormattedMax).optional(),
  "streetNumber": zod.string().max(propertiesListResponseAddressOneStreetNumberMax).optional(),
  "street": zod.string(),
  "city": zod.string().nullable(),
  "postalCode": zod.string().nullable(),
  "state": zod.string().nullable(),
  "country": zod.string().nullable()
}).strict().nullable(),
  "region": zod.string().max(propertiesListResponseRegionMax).nullish(),
  "clientId": zod.string().max(propertiesListResponseClientIdMax).nullish(),
  "timeZone": zod.string().optional(),
  "lat": zod.number().nullable().default(propertiesListResponseLatDefault),
  "lng": zod.number().nullable().default(propertiesListResponseLngDefault),
  "propertyManager": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string(),
  "owner": zod.object({
  "id": zod.string().uuid(),
  "username": zod.string().max(propertiesListResponsePropertyManagerOneOwnerOneUsernameMax).regex(propertiesListResponsePropertyManagerOneOwnerOneUsernameRegExp).describe('Required. 150 characters or fewer. Letters, digits and @\/.\/+\/-\/_ only.'),
  "email": zod.string().email().max(propertiesListResponsePropertyManagerOneOwnerOneEmailMax).optional(),
  "phoneNumber": zod.string().max(propertiesListResponsePropertyManagerOneOwnerOnePhoneNumberMax).optional(),
  "fullName": zod.string(),
  "consultantGroup": zod.string().nullable(),
  "clientGroup": zod.string().nullable(),
  "role": zod.union([zod.enum(['consultant', 'client', 'service_provider']).describe('\* `consultant` - consultant\n\* `client` - client\n\* `service_provider` - service_provider'),zod.literal(null)]).nullable(),
  "isLiftaiAdmin": zod.boolean(),
  "isGroupAdmin": zod.boolean()
}).strict().nullable()
}).strict().nullable(),
  "consultantGroup": zod.object({
  "name": zod.string(),
  "id": zod.string().uuid(),
  "owner": zod.object({
  "id": zod.string().uuid(),
  "username": zod.string().max(propertiesListResponseConsultantGroupOneOwnerOneUsernameMax).regex(propertiesListResponseConsultantGroupOneOwnerOneUsernameRegExp).describe('Required. 150 characters or fewer. Letters, digits and @\/.\/+\/-\/_ only.'),
  "fullName": zod.string(),
  "email": zod.string().email().max(propertiesListResponseConsultantGroupOneOwnerOneEmailMax).optional(),
  "phoneNumber": zod.string().max(propertiesListResponseConsultantGroupOneOwnerOnePhoneNumberMax).optional()
}).strict().nullable(),
  "consultants": zod.array(zod.object({
  "id": zod.string().uuid(),
  "username": zod.string().max(propertiesListResponseConsultantGroupOneConsultantsItemUsernameMax).regex(propertiesListResponseConsultantGroupOneConsultantsItemUsernameRegExp).describe('Required. 150 characters or fewer. Letters, digits and @\/.\/+\/-\/_ only.'),
  "fullName": zod.string(),
  "email": zod.string().email().max(propertiesListResponseConsultantGroupOneConsultantsItemEmailMax).optional(),
  "phoneNumber": zod.string().max(propertiesListResponseConsultantGroupOneConsultantsItemPhoneNumberMax).optional()
}).strict()),
  "file": zod.string().url().regex(propertiesListResponseConsultantGroupOneFileRegExp).nullish()
}).strict().nullable(),
  "assignedConsultant": zod.object({
  "id": zod.string().uuid(),
  "username": zod.string().max(propertiesListResponseAssignedConsultantOneUsernameMax).regex(propertiesListResponseAssignedConsultantOneUsernameRegExp).describe('Required. 150 characters or fewer. Letters, digits and @\/.\/+\/-\/_ only.'),
  "email": zod.string().email().max(propertiesListResponseAssignedConsultantOneEmailMax).optional(),
  "phoneNumber": zod.string().max(propertiesListResponseAssignedConsultantOnePhoneNumberMax).optional(),
  "fullName": zod.string(),
  "consultantGroup": zod.string().nullable(),
  "clientGroup": zod.string().nullable(),
  "role": zod.union([zod.enum(['consultant', 'client', 'service_provider']).describe('\* `consultant` - consultant\n\* `client` - client\n\* `service_provider` - service_provider'),zod.literal(null)]).nullable(),
  "isLiftaiAdmin": zod.boolean(),
  "isGroupAdmin": zod.boolean()
}).strict().nullable(),
  "portfolio": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string()
}).strict().nullable(),
  "unitCount": zod.number(),
  "buildingNumber": zod.string().max(propertiesListResponseBuildingNumberMax).optional(),
  "contact": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string().max(propertiesListResponseContactOneNameMax),
  "email": zod.string().email().nullish(),
  "phone": zod.string().nullish(),
  "createdAt": zod.string().datetime({"offset":true}),
  "updatedAt": zod.string().datetime({"offset":true})
}).strict().nullish()
}).strict().describe('A subclass of DRF\'s ModelSerializer which realizes when fields it is\nserializing are to related objects which also have NestableModelSerializers\ndefined for them and uses those serializers instead of the default\nModelSerializer that DRF would use.\n\nThis ModelSerializer takes an additional `fields` argument that\ncontrols which fields should be displayed.\nFor more information, refer to the documentation:\nhttps:\/\/www.django-rest-framework.org\/api-guide\/serializers\/#dynamically-modifying-fields\n\n\nExample:\nPortfolioSerializer(required=False, fields=[\"id\", \"name\"])')
export const PropertiesListResponse = zod.array(PropertiesListResponseItem)

/**
 * Adds a GET-only ``aggregate`` action to a viewset.
 *
 * The viewset must declare ``AGGREGATE_CONFIG: AggregateConfig`` and a
 * ``filterset_class``. GET-only because the chat loopback only issues GET.
 */

export const propertiesCreateBodyAddressOneRawMax = 200;

export const propertiesCreateBodyAddressOneFormattedMax = 200;

export const propertiesCreateBodyAddressOneStreetNumberMax = 20;

export const propertiesCreateBodyRegionMax = 255;

export const propertiesCreateBodyClientIdMax = 255;

export const propertiesCreateBodyBuildingNumberMax = 255;

export const propertiesCreateBodyContactOneNameMax = 255;



export const PropertiesCreateBody = zod.object({
  "name": zod.string().min(1),
  "address": zod.object({
  "raw": zod.string().min(1).max(propertiesCreateBodyAddressOneRawMax),
  "formatted": zod.string().max(propertiesCreateBodyAddressOneFormattedMax).optional(),
  "streetNumber": zod.string().max(propertiesCreateBodyAddressOneStreetNumberMax).optional()
}).describe('A subclass of DRF\'s ModelSerializer which realizes when fields it is\nserializing are to related objects which also have NestableModelSerializers\ndefined for them and uses those serializers instead of the default\nModelSerializer that DRF would use.\n\nThis ModelSerializer takes an additional `fields` argument that\ncontrols which fields should be displayed.\nFor more information, refer to the documentation:\nhttps:\/\/www.django-rest-framework.org\/api-guide\/serializers\/#dynamically-modifying-fields\n\n\nExample:\nPortfolioSerializer(required=False, fields=[\"id\", \"name\"])').nullable(),
  "region": zod.string().max(propertiesCreateBodyRegionMax).nullish(),
  "clientId": zod.string().max(propertiesCreateBodyClientIdMax).nullish(),
  "timeZone": zod.string().optional(),
  "buildingNumber": zod.string().max(propertiesCreateBodyBuildingNumberMax).optional(),
  "contact": zod.object({
  "name": zod.string().min(1).max(propertiesCreateBodyContactOneNameMax),
  "email": zod.string().email().nullish(),
  "phone": zod.string().nullish()
}).describe('A subclass of DRF\'s ModelSerializer which realizes when fields it is\nserializing are to related objects which also have NestableModelSerializers\ndefined for them and uses those serializers instead of the default\nModelSerializer that DRF would use.\n\nThis ModelSerializer takes an additional `fields` argument that\ncontrols which fields should be displayed.\nFor more information, refer to the documentation:\nhttps:\/\/www.django-rest-framework.org\/api-guide\/serializers\/#dynamically-modifying-fields\n\n\nExample:\nPortfolioSerializer(required=False, fields=[\"id\", \"name\"])').nullish()
}).describe('A subclass of DRF\'s ModelSerializer which realizes when fields it is\nserializing are to related objects which also have NestableModelSerializers\ndefined for them and uses those serializers instead of the default\nModelSerializer that DRF would use.\n\nThis ModelSerializer takes an additional `fields` argument that\ncontrols which fields should be displayed.\nFor more information, refer to the documentation:\nhttps:\/\/www.django-rest-framework.org\/api-guide\/serializers\/#dynamically-modifying-fields\n\n\nExample:\nPortfolioSerializer(required=False, fields=[\"id\", \"name\"])')

export const propertiesCreateResponseAddressOneRawMax = 200;

export const propertiesCreateResponseAddressOneFormattedMax = 200;

export const propertiesCreateResponseAddressOneStreetNumberMax = 20;

export const propertiesCreateResponseRegionMax = 255;

export const propertiesCreateResponseClientIdMax = 255;

export const propertiesCreateResponseLatDefault = 0;
export const propertiesCreateResponseLngDefault = 0;
export const propertiesCreateResponsePropertyManagerOneOwnerOneUsernameMax = 150;


export const propertiesCreateResponsePropertyManagerOneOwnerOneUsernameRegExp = new RegExp('^[\\w.@+-]+$');
export const propertiesCreateResponsePropertyManagerOneOwnerOneEmailMax = 254;

export const propertiesCreateResponsePropertyManagerOneOwnerOnePhoneNumberMax = 128;

export const propertiesCreateResponseConsultantGroupOneOwnerOneUsernameMax = 150;


export const propertiesCreateResponseConsultantGroupOneOwnerOneUsernameRegExp = new RegExp('^[\\w.@+-]+$');
export const propertiesCreateResponseConsultantGroupOneOwnerOneEmailMax = 254;

export const propertiesCreateResponseConsultantGroupOneOwnerOnePhoneNumberMax = 128;

export const propertiesCreateResponseConsultantGroupOneConsultantsItemUsernameMax = 150;


export const propertiesCreateResponseConsultantGroupOneConsultantsItemUsernameRegExp = new RegExp('^[\\w.@+-]+$');
export const propertiesCreateResponseConsultantGroupOneConsultantsItemEmailMax = 254;

export const propertiesCreateResponseConsultantGroupOneConsultantsItemPhoneNumberMax = 128;

export const propertiesCreateResponseConsultantGroupOneFileRegExp = new RegExp('(?:jpg|png|jpeg)$');
export const propertiesCreateResponseAssignedConsultantOneUsernameMax = 150;


export const propertiesCreateResponseAssignedConsultantOneUsernameRegExp = new RegExp('^[\\w.@+-]+$');
export const propertiesCreateResponseAssignedConsultantOneEmailMax = 254;

export const propertiesCreateResponseAssignedConsultantOnePhoneNumberMax = 128;

export const propertiesCreateResponseBuildingNumberMax = 255;

export const propertiesCreateResponseContactOneNameMax = 255;



export const PropertiesCreateResponse = zod.object({
  "id": zod.string().uuid(),
  "createdAt": zod.string().datetime({"offset":true}),
  "updatedAt": zod.string().datetime({"offset":true}).nullable(),
  "name": zod.string(),
  "address": zod.object({
  "id": zod.number(),
  "raw": zod.string().max(propertiesCreateResponseAddressOneRawMax),
  "formatted": zod.string().max(propertiesCreateResponseAddressOneFormattedMax).optional(),
  "streetNumber": zod.string().max(propertiesCreateResponseAddressOneStreetNumberMax).optional(),
  "street": zod.string(),
  "city": zod.string().nullable(),
  "postalCode": zod.string().nullable(),
  "state": zod.string().nullable(),
  "country": zod.string().nullable()
}).strict().nullable(),
  "region": zod.string().max(propertiesCreateResponseRegionMax).nullish(),
  "clientId": zod.string().max(propertiesCreateResponseClientIdMax).nullish(),
  "timeZone": zod.string().optional(),
  "lat": zod.number().nullable().default(propertiesCreateResponseLatDefault),
  "lng": zod.number().nullable().default(propertiesCreateResponseLngDefault),
  "propertyManager": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string(),
  "owner": zod.object({
  "id": zod.string().uuid(),
  "username": zod.string().max(propertiesCreateResponsePropertyManagerOneOwnerOneUsernameMax).regex(propertiesCreateResponsePropertyManagerOneOwnerOneUsernameRegExp).describe('Required. 150 characters or fewer. Letters, digits and @\/.\/+\/-\/_ only.'),
  "email": zod.string().email().max(propertiesCreateResponsePropertyManagerOneOwnerOneEmailMax).optional(),
  "phoneNumber": zod.string().max(propertiesCreateResponsePropertyManagerOneOwnerOnePhoneNumberMax).optional(),
  "fullName": zod.string(),
  "consultantGroup": zod.string().nullable(),
  "clientGroup": zod.string().nullable(),
  "role": zod.union([zod.enum(['consultant', 'client', 'service_provider']).describe('\* `consultant` - consultant\n\* `client` - client\n\* `service_provider` - service_provider'),zod.literal(null)]).nullable(),
  "isLiftaiAdmin": zod.boolean(),
  "isGroupAdmin": zod.boolean()
}).strict().nullable()
}).strict().nullable(),
  "consultantGroup": zod.object({
  "name": zod.string(),
  "id": zod.string().uuid(),
  "owner": zod.object({
  "id": zod.string().uuid(),
  "username": zod.string().max(propertiesCreateResponseConsultantGroupOneOwnerOneUsernameMax).regex(propertiesCreateResponseConsultantGroupOneOwnerOneUsernameRegExp).describe('Required. 150 characters or fewer. Letters, digits and @\/.\/+\/-\/_ only.'),
  "fullName": zod.string(),
  "email": zod.string().email().max(propertiesCreateResponseConsultantGroupOneOwnerOneEmailMax).optional(),
  "phoneNumber": zod.string().max(propertiesCreateResponseConsultantGroupOneOwnerOnePhoneNumberMax).optional()
}).strict().nullable(),
  "consultants": zod.array(zod.object({
  "id": zod.string().uuid(),
  "username": zod.string().max(propertiesCreateResponseConsultantGroupOneConsultantsItemUsernameMax).regex(propertiesCreateResponseConsultantGroupOneConsultantsItemUsernameRegExp).describe('Required. 150 characters or fewer. Letters, digits and @\/.\/+\/-\/_ only.'),
  "fullName": zod.string(),
  "email": zod.string().email().max(propertiesCreateResponseConsultantGroupOneConsultantsItemEmailMax).optional(),
  "phoneNumber": zod.string().max(propertiesCreateResponseConsultantGroupOneConsultantsItemPhoneNumberMax).optional()
}).strict()),
  "file": zod.string().url().regex(propertiesCreateResponseConsultantGroupOneFileRegExp).nullish()
}).strict().nullable(),
  "assignedConsultant": zod.object({
  "id": zod.string().uuid(),
  "username": zod.string().max(propertiesCreateResponseAssignedConsultantOneUsernameMax).regex(propertiesCreateResponseAssignedConsultantOneUsernameRegExp).describe('Required. 150 characters or fewer. Letters, digits and @\/.\/+\/-\/_ only.'),
  "email": zod.string().email().max(propertiesCreateResponseAssignedConsultantOneEmailMax).optional(),
  "phoneNumber": zod.string().max(propertiesCreateResponseAssignedConsultantOnePhoneNumberMax).optional(),
  "fullName": zod.string(),
  "consultantGroup": zod.string().nullable(),
  "clientGroup": zod.string().nullable(),
  "role": zod.union([zod.enum(['consultant', 'client', 'service_provider']).describe('\* `consultant` - consultant\n\* `client` - client\n\* `service_provider` - service_provider'),zod.literal(null)]).nullable(),
  "isLiftaiAdmin": zod.boolean(),
  "isGroupAdmin": zod.boolean()
}).strict().nullable(),
  "portfolio": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string()
}).strict().nullable(),
  "unitCount": zod.number(),
  "buildingNumber": zod.string().max(propertiesCreateResponseBuildingNumberMax).optional(),
  "contact": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string().max(propertiesCreateResponseContactOneNameMax),
  "email": zod.string().email().nullish(),
  "phone": zod.string().nullish(),
  "createdAt": zod.string().datetime({"offset":true}),
  "updatedAt": zod.string().datetime({"offset":true})
}).strict().nullish()
}).strict().describe('A subclass of DRF\'s ModelSerializer which realizes when fields it is\nserializing are to related objects which also have NestableModelSerializers\ndefined for them and uses those serializers instead of the default\nModelSerializer that DRF would use.\n\nThis ModelSerializer takes an additional `fields` argument that\ncontrols which fields should be displayed.\nFor more information, refer to the documentation:\nhttps:\/\/www.django-rest-framework.org\/api-guide\/serializers\/#dynamically-modifying-fields\n\n\nExample:\nPortfolioSerializer(required=False, fields=[\"id\", \"name\"])')

/**
 * Adds a GET-only ``aggregate`` action to a viewset.
 *
 * The viewset must declare ``AGGREGATE_CONFIG: AggregateConfig`` and a
 * ``filterset_class``. GET-only because the chat loopback only issues GET.
 */
export const PropertiesRetrieveParams = zod.object({
  "id": zod.string().uuid().describe('A UUID string identifying this property.')
})

export const propertiesRetrieveResponseAddressOneRawMax = 200;

export const propertiesRetrieveResponseAddressOneFormattedMax = 200;

export const propertiesRetrieveResponseAddressOneStreetNumberMax = 20;

export const propertiesRetrieveResponseRegionMax = 255;

export const propertiesRetrieveResponseClientIdMax = 255;

export const propertiesRetrieveResponseLatDefault = 0;
export const propertiesRetrieveResponseLngDefault = 0;
export const propertiesRetrieveResponsePropertyManagerOneOwnerOneUsernameMax = 150;


export const propertiesRetrieveResponsePropertyManagerOneOwnerOneUsernameRegExp = new RegExp('^[\\w.@+-]+$');
export const propertiesRetrieveResponsePropertyManagerOneOwnerOneEmailMax = 254;

export const propertiesRetrieveResponsePropertyManagerOneOwnerOnePhoneNumberMax = 128;

export const propertiesRetrieveResponseConsultantGroupOneOwnerOneUsernameMax = 150;


export const propertiesRetrieveResponseConsultantGroupOneOwnerOneUsernameRegExp = new RegExp('^[\\w.@+-]+$');
export const propertiesRetrieveResponseConsultantGroupOneOwnerOneEmailMax = 254;

export const propertiesRetrieveResponseConsultantGroupOneOwnerOnePhoneNumberMax = 128;

export const propertiesRetrieveResponseConsultantGroupOneConsultantsItemUsernameMax = 150;


export const propertiesRetrieveResponseConsultantGroupOneConsultantsItemUsernameRegExp = new RegExp('^[\\w.@+-]+$');
export const propertiesRetrieveResponseConsultantGroupOneConsultantsItemEmailMax = 254;

export const propertiesRetrieveResponseConsultantGroupOneConsultantsItemPhoneNumberMax = 128;

export const propertiesRetrieveResponseConsultantGroupOneFileRegExp = new RegExp('(?:jpg|png|jpeg)$');
export const propertiesRetrieveResponseAssignedConsultantOneUsernameMax = 150;


export const propertiesRetrieveResponseAssignedConsultantOneUsernameRegExp = new RegExp('^[\\w.@+-]+$');
export const propertiesRetrieveResponseAssignedConsultantOneEmailMax = 254;

export const propertiesRetrieveResponseAssignedConsultantOnePhoneNumberMax = 128;

export const propertiesRetrieveResponseBuildingNumberMax = 255;

export const propertiesRetrieveResponseContactOneNameMax = 255;



export const PropertiesRetrieveResponse = zod.object({
  "id": zod.string().uuid(),
  "createdAt": zod.string().datetime({"offset":true}),
  "updatedAt": zod.string().datetime({"offset":true}).nullable(),
  "name": zod.string(),
  "address": zod.object({
  "id": zod.number(),
  "raw": zod.string().max(propertiesRetrieveResponseAddressOneRawMax),
  "formatted": zod.string().max(propertiesRetrieveResponseAddressOneFormattedMax).optional(),
  "streetNumber": zod.string().max(propertiesRetrieveResponseAddressOneStreetNumberMax).optional(),
  "street": zod.string(),
  "city": zod.string().nullable(),
  "postalCode": zod.string().nullable(),
  "state": zod.string().nullable(),
  "country": zod.string().nullable()
}).strict().nullable(),
  "region": zod.string().max(propertiesRetrieveResponseRegionMax).nullish(),
  "clientId": zod.string().max(propertiesRetrieveResponseClientIdMax).nullish(),
  "timeZone": zod.string().optional(),
  "lat": zod.number().nullable().default(propertiesRetrieveResponseLatDefault),
  "lng": zod.number().nullable().default(propertiesRetrieveResponseLngDefault),
  "propertyManager": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string(),
  "owner": zod.object({
  "id": zod.string().uuid(),
  "username": zod.string().max(propertiesRetrieveResponsePropertyManagerOneOwnerOneUsernameMax).regex(propertiesRetrieveResponsePropertyManagerOneOwnerOneUsernameRegExp).describe('Required. 150 characters or fewer. Letters, digits and @\/.\/+\/-\/_ only.'),
  "email": zod.string().email().max(propertiesRetrieveResponsePropertyManagerOneOwnerOneEmailMax).optional(),
  "phoneNumber": zod.string().max(propertiesRetrieveResponsePropertyManagerOneOwnerOnePhoneNumberMax).optional(),
  "fullName": zod.string(),
  "consultantGroup": zod.string().nullable(),
  "clientGroup": zod.string().nullable(),
  "role": zod.union([zod.enum(['consultant', 'client', 'service_provider']).describe('\* `consultant` - consultant\n\* `client` - client\n\* `service_provider` - service_provider'),zod.literal(null)]).nullable(),
  "isLiftaiAdmin": zod.boolean(),
  "isGroupAdmin": zod.boolean()
}).strict().nullable()
}).strict().nullable(),
  "consultantGroup": zod.object({
  "name": zod.string(),
  "id": zod.string().uuid(),
  "owner": zod.object({
  "id": zod.string().uuid(),
  "username": zod.string().max(propertiesRetrieveResponseConsultantGroupOneOwnerOneUsernameMax).regex(propertiesRetrieveResponseConsultantGroupOneOwnerOneUsernameRegExp).describe('Required. 150 characters or fewer. Letters, digits and @\/.\/+\/-\/_ only.'),
  "fullName": zod.string(),
  "email": zod.string().email().max(propertiesRetrieveResponseConsultantGroupOneOwnerOneEmailMax).optional(),
  "phoneNumber": zod.string().max(propertiesRetrieveResponseConsultantGroupOneOwnerOnePhoneNumberMax).optional()
}).strict().nullable(),
  "consultants": zod.array(zod.object({
  "id": zod.string().uuid(),
  "username": zod.string().max(propertiesRetrieveResponseConsultantGroupOneConsultantsItemUsernameMax).regex(propertiesRetrieveResponseConsultantGroupOneConsultantsItemUsernameRegExp).describe('Required. 150 characters or fewer. Letters, digits and @\/.\/+\/-\/_ only.'),
  "fullName": zod.string(),
  "email": zod.string().email().max(propertiesRetrieveResponseConsultantGroupOneConsultantsItemEmailMax).optional(),
  "phoneNumber": zod.string().max(propertiesRetrieveResponseConsultantGroupOneConsultantsItemPhoneNumberMax).optional()
}).strict()),
  "file": zod.string().url().regex(propertiesRetrieveResponseConsultantGroupOneFileRegExp).nullish()
}).strict().nullable(),
  "assignedConsultant": zod.object({
  "id": zod.string().uuid(),
  "username": zod.string().max(propertiesRetrieveResponseAssignedConsultantOneUsernameMax).regex(propertiesRetrieveResponseAssignedConsultantOneUsernameRegExp).describe('Required. 150 characters or fewer. Letters, digits and @\/.\/+\/-\/_ only.'),
  "email": zod.string().email().max(propertiesRetrieveResponseAssignedConsultantOneEmailMax).optional(),
  "phoneNumber": zod.string().max(propertiesRetrieveResponseAssignedConsultantOnePhoneNumberMax).optional(),
  "fullName": zod.string(),
  "consultantGroup": zod.string().nullable(),
  "clientGroup": zod.string().nullable(),
  "role": zod.union([zod.enum(['consultant', 'client', 'service_provider']).describe('\* `consultant` - consultant\n\* `client` - client\n\* `service_provider` - service_provider'),zod.literal(null)]).nullable(),
  "isLiftaiAdmin": zod.boolean(),
  "isGroupAdmin": zod.boolean()
}).strict().nullable(),
  "portfolio": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string()
}).strict().nullable(),
  "unitCount": zod.number(),
  "buildingNumber": zod.string().max(propertiesRetrieveResponseBuildingNumberMax).optional(),
  "contact": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string().max(propertiesRetrieveResponseContactOneNameMax),
  "email": zod.string().email().nullish(),
  "phone": zod.string().nullish(),
  "createdAt": zod.string().datetime({"offset":true}),
  "updatedAt": zod.string().datetime({"offset":true})
}).strict().nullish()
}).strict().describe('A subclass of DRF\'s ModelSerializer which realizes when fields it is\nserializing are to related objects which also have NestableModelSerializers\ndefined for them and uses those serializers instead of the default\nModelSerializer that DRF would use.\n\nThis ModelSerializer takes an additional `fields` argument that\ncontrols which fields should be displayed.\nFor more information, refer to the documentation:\nhttps:\/\/www.django-rest-framework.org\/api-guide\/serializers\/#dynamically-modifying-fields\n\n\nExample:\nPortfolioSerializer(required=False, fields=[\"id\", \"name\"])')

/**
 * Adds a GET-only ``aggregate`` action to a viewset.
 *
 * The viewset must declare ``AGGREGATE_CONFIG: AggregateConfig`` and a
 * ``filterset_class``. GET-only because the chat loopback only issues GET.
 */
export const PropertiesUpdateParams = zod.object({
  "id": zod.string().uuid().describe('A UUID string identifying this property.')
})


export const propertiesUpdateBodyAddressOneRawMax = 200;

export const propertiesUpdateBodyAddressOneFormattedMax = 200;

export const propertiesUpdateBodyAddressOneStreetNumberMax = 20;

export const propertiesUpdateBodyRegionMax = 255;

export const propertiesUpdateBodyClientIdMax = 255;

export const propertiesUpdateBodyBuildingNumberMax = 255;

export const propertiesUpdateBodyContactOneNameMax = 255;



export const PropertiesUpdateBody = zod.object({
  "name": zod.string().min(1),
  "address": zod.object({
  "raw": zod.string().min(1).max(propertiesUpdateBodyAddressOneRawMax),
  "formatted": zod.string().max(propertiesUpdateBodyAddressOneFormattedMax).optional(),
  "streetNumber": zod.string().max(propertiesUpdateBodyAddressOneStreetNumberMax).optional()
}).describe('A subclass of DRF\'s ModelSerializer which realizes when fields it is\nserializing are to related objects which also have NestableModelSerializers\ndefined for them and uses those serializers instead of the default\nModelSerializer that DRF would use.\n\nThis ModelSerializer takes an additional `fields` argument that\ncontrols which fields should be displayed.\nFor more information, refer to the documentation:\nhttps:\/\/www.django-rest-framework.org\/api-guide\/serializers\/#dynamically-modifying-fields\n\n\nExample:\nPortfolioSerializer(required=False, fields=[\"id\", \"name\"])').nullable(),
  "region": zod.string().max(propertiesUpdateBodyRegionMax).nullish(),
  "clientId": zod.string().max(propertiesUpdateBodyClientIdMax).nullish(),
  "timeZone": zod.string().optional(),
  "buildingNumber": zod.string().max(propertiesUpdateBodyBuildingNumberMax).optional(),
  "contact": zod.object({
  "name": zod.string().min(1).max(propertiesUpdateBodyContactOneNameMax),
  "email": zod.string().email().nullish(),
  "phone": zod.string().nullish()
}).describe('A subclass of DRF\'s ModelSerializer which realizes when fields it is\nserializing are to related objects which also have NestableModelSerializers\ndefined for them and uses those serializers instead of the default\nModelSerializer that DRF would use.\n\nThis ModelSerializer takes an additional `fields` argument that\ncontrols which fields should be displayed.\nFor more information, refer to the documentation:\nhttps:\/\/www.django-rest-framework.org\/api-guide\/serializers\/#dynamically-modifying-fields\n\n\nExample:\nPortfolioSerializer(required=False, fields=[\"id\", \"name\"])').nullish()
}).describe('A subclass of DRF\'s ModelSerializer which realizes when fields it is\nserializing are to related objects which also have NestableModelSerializers\ndefined for them and uses those serializers instead of the default\nModelSerializer that DRF would use.\n\nThis ModelSerializer takes an additional `fields` argument that\ncontrols which fields should be displayed.\nFor more information, refer to the documentation:\nhttps:\/\/www.django-rest-framework.org\/api-guide\/serializers\/#dynamically-modifying-fields\n\n\nExample:\nPortfolioSerializer(required=False, fields=[\"id\", \"name\"])')

export const propertiesUpdateResponseAddressOneRawMax = 200;

export const propertiesUpdateResponseAddressOneFormattedMax = 200;

export const propertiesUpdateResponseAddressOneStreetNumberMax = 20;

export const propertiesUpdateResponseRegionMax = 255;

export const propertiesUpdateResponseClientIdMax = 255;

export const propertiesUpdateResponseLatDefault = 0;
export const propertiesUpdateResponseLngDefault = 0;
export const propertiesUpdateResponsePropertyManagerOneOwnerOneUsernameMax = 150;


export const propertiesUpdateResponsePropertyManagerOneOwnerOneUsernameRegExp = new RegExp('^[\\w.@+-]+$');
export const propertiesUpdateResponsePropertyManagerOneOwnerOneEmailMax = 254;

export const propertiesUpdateResponsePropertyManagerOneOwnerOnePhoneNumberMax = 128;

export const propertiesUpdateResponseConsultantGroupOneOwnerOneUsernameMax = 150;


export const propertiesUpdateResponseConsultantGroupOneOwnerOneUsernameRegExp = new RegExp('^[\\w.@+-]+$');
export const propertiesUpdateResponseConsultantGroupOneOwnerOneEmailMax = 254;

export const propertiesUpdateResponseConsultantGroupOneOwnerOnePhoneNumberMax = 128;

export const propertiesUpdateResponseConsultantGroupOneConsultantsItemUsernameMax = 150;


export const propertiesUpdateResponseConsultantGroupOneConsultantsItemUsernameRegExp = new RegExp('^[\\w.@+-]+$');
export const propertiesUpdateResponseConsultantGroupOneConsultantsItemEmailMax = 254;

export const propertiesUpdateResponseConsultantGroupOneConsultantsItemPhoneNumberMax = 128;

export const propertiesUpdateResponseConsultantGroupOneFileRegExp = new RegExp('(?:jpg|png|jpeg)$');
export const propertiesUpdateResponseAssignedConsultantOneUsernameMax = 150;


export const propertiesUpdateResponseAssignedConsultantOneUsernameRegExp = new RegExp('^[\\w.@+-]+$');
export const propertiesUpdateResponseAssignedConsultantOneEmailMax = 254;

export const propertiesUpdateResponseAssignedConsultantOnePhoneNumberMax = 128;

export const propertiesUpdateResponseBuildingNumberMax = 255;

export const propertiesUpdateResponseContactOneNameMax = 255;



export const PropertiesUpdateResponse = zod.object({
  "id": zod.string().uuid(),
  "createdAt": zod.string().datetime({"offset":true}),
  "updatedAt": zod.string().datetime({"offset":true}).nullable(),
  "name": zod.string(),
  "address": zod.object({
  "id": zod.number(),
  "raw": zod.string().max(propertiesUpdateResponseAddressOneRawMax),
  "formatted": zod.string().max(propertiesUpdateResponseAddressOneFormattedMax).optional(),
  "streetNumber": zod.string().max(propertiesUpdateResponseAddressOneStreetNumberMax).optional(),
  "street": zod.string(),
  "city": zod.string().nullable(),
  "postalCode": zod.string().nullable(),
  "state": zod.string().nullable(),
  "country": zod.string().nullable()
}).strict().nullable(),
  "region": zod.string().max(propertiesUpdateResponseRegionMax).nullish(),
  "clientId": zod.string().max(propertiesUpdateResponseClientIdMax).nullish(),
  "timeZone": zod.string().optional(),
  "lat": zod.number().nullable().default(propertiesUpdateResponseLatDefault),
  "lng": zod.number().nullable().default(propertiesUpdateResponseLngDefault),
  "propertyManager": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string(),
  "owner": zod.object({
  "id": zod.string().uuid(),
  "username": zod.string().max(propertiesUpdateResponsePropertyManagerOneOwnerOneUsernameMax).regex(propertiesUpdateResponsePropertyManagerOneOwnerOneUsernameRegExp).describe('Required. 150 characters or fewer. Letters, digits and @\/.\/+\/-\/_ only.'),
  "email": zod.string().email().max(propertiesUpdateResponsePropertyManagerOneOwnerOneEmailMax).optional(),
  "phoneNumber": zod.string().max(propertiesUpdateResponsePropertyManagerOneOwnerOnePhoneNumberMax).optional(),
  "fullName": zod.string(),
  "consultantGroup": zod.string().nullable(),
  "clientGroup": zod.string().nullable(),
  "role": zod.union([zod.enum(['consultant', 'client', 'service_provider']).describe('\* `consultant` - consultant\n\* `client` - client\n\* `service_provider` - service_provider'),zod.literal(null)]).nullable(),
  "isLiftaiAdmin": zod.boolean(),
  "isGroupAdmin": zod.boolean()
}).strict().nullable()
}).strict().nullable(),
  "consultantGroup": zod.object({
  "name": zod.string(),
  "id": zod.string().uuid(),
  "owner": zod.object({
  "id": zod.string().uuid(),
  "username": zod.string().max(propertiesUpdateResponseConsultantGroupOneOwnerOneUsernameMax).regex(propertiesUpdateResponseConsultantGroupOneOwnerOneUsernameRegExp).describe('Required. 150 characters or fewer. Letters, digits and @\/.\/+\/-\/_ only.'),
  "fullName": zod.string(),
  "email": zod.string().email().max(propertiesUpdateResponseConsultantGroupOneOwnerOneEmailMax).optional(),
  "phoneNumber": zod.string().max(propertiesUpdateResponseConsultantGroupOneOwnerOnePhoneNumberMax).optional()
}).strict().nullable(),
  "consultants": zod.array(zod.object({
  "id": zod.string().uuid(),
  "username": zod.string().max(propertiesUpdateResponseConsultantGroupOneConsultantsItemUsernameMax).regex(propertiesUpdateResponseConsultantGroupOneConsultantsItemUsernameRegExp).describe('Required. 150 characters or fewer. Letters, digits and @\/.\/+\/-\/_ only.'),
  "fullName": zod.string(),
  "email": zod.string().email().max(propertiesUpdateResponseConsultantGroupOneConsultantsItemEmailMax).optional(),
  "phoneNumber": zod.string().max(propertiesUpdateResponseConsultantGroupOneConsultantsItemPhoneNumberMax).optional()
}).strict()),
  "file": zod.string().url().regex(propertiesUpdateResponseConsultantGroupOneFileRegExp).nullish()
}).strict().nullable(),
  "assignedConsultant": zod.object({
  "id": zod.string().uuid(),
  "username": zod.string().max(propertiesUpdateResponseAssignedConsultantOneUsernameMax).regex(propertiesUpdateResponseAssignedConsultantOneUsernameRegExp).describe('Required. 150 characters or fewer. Letters, digits and @\/.\/+\/-\/_ only.'),
  "email": zod.string().email().max(propertiesUpdateResponseAssignedConsultantOneEmailMax).optional(),
  "phoneNumber": zod.string().max(propertiesUpdateResponseAssignedConsultantOnePhoneNumberMax).optional(),
  "fullName": zod.string(),
  "consultantGroup": zod.string().nullable(),
  "clientGroup": zod.string().nullable(),
  "role": zod.union([zod.enum(['consultant', 'client', 'service_provider']).describe('\* `consultant` - consultant\n\* `client` - client\n\* `service_provider` - service_provider'),zod.literal(null)]).nullable(),
  "isLiftaiAdmin": zod.boolean(),
  "isGroupAdmin": zod.boolean()
}).strict().nullable(),
  "portfolio": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string()
}).strict().nullable(),
  "unitCount": zod.number(),
  "buildingNumber": zod.string().max(propertiesUpdateResponseBuildingNumberMax).optional(),
  "contact": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string().max(propertiesUpdateResponseContactOneNameMax),
  "email": zod.string().email().nullish(),
  "phone": zod.string().nullish(),
  "createdAt": zod.string().datetime({"offset":true}),
  "updatedAt": zod.string().datetime({"offset":true})
}).strict().nullish()
}).strict().describe('A subclass of DRF\'s ModelSerializer which realizes when fields it is\nserializing are to related objects which also have NestableModelSerializers\ndefined for them and uses those serializers instead of the default\nModelSerializer that DRF would use.\n\nThis ModelSerializer takes an additional `fields` argument that\ncontrols which fields should be displayed.\nFor more information, refer to the documentation:\nhttps:\/\/www.django-rest-framework.org\/api-guide\/serializers\/#dynamically-modifying-fields\n\n\nExample:\nPortfolioSerializer(required=False, fields=[\"id\", \"name\"])')

/**
 * Adds a GET-only ``aggregate`` action to a viewset.
 *
 * The viewset must declare ``AGGREGATE_CONFIG: AggregateConfig`` and a
 * ``filterset_class``. GET-only because the chat loopback only issues GET.
 */
export const PropertiesPartialUpdateParams = zod.object({
  "id": zod.string().uuid().describe('A UUID string identifying this property.')
})


export const propertiesPartialUpdateBodyAddressOneRawMax = 200;

export const propertiesPartialUpdateBodyAddressOneFormattedMax = 200;

export const propertiesPartialUpdateBodyAddressOneStreetNumberMax = 20;

export const propertiesPartialUpdateBodyRegionMax = 255;

export const propertiesPartialUpdateBodyClientIdMax = 255;

export const propertiesPartialUpdateBodyBuildingNumberMax = 255;

export const propertiesPartialUpdateBodyContactOneNameMax = 255;



export const PropertiesPartialUpdateBody = zod.object({
  "name": zod.string().min(1).optional(),
  "address": zod.object({
  "raw": zod.string().min(1).max(propertiesPartialUpdateBodyAddressOneRawMax),
  "formatted": zod.string().max(propertiesPartialUpdateBodyAddressOneFormattedMax).optional(),
  "streetNumber": zod.string().max(propertiesPartialUpdateBodyAddressOneStreetNumberMax).optional()
}).describe('A subclass of DRF\'s ModelSerializer which realizes when fields it is\nserializing are to related objects which also have NestableModelSerializers\ndefined for them and uses those serializers instead of the default\nModelSerializer that DRF would use.\n\nThis ModelSerializer takes an additional `fields` argument that\ncontrols which fields should be displayed.\nFor more information, refer to the documentation:\nhttps:\/\/www.django-rest-framework.org\/api-guide\/serializers\/#dynamically-modifying-fields\n\n\nExample:\nPortfolioSerializer(required=False, fields=[\"id\", \"name\"])').nullish(),
  "region": zod.string().max(propertiesPartialUpdateBodyRegionMax).nullish(),
  "clientId": zod.string().max(propertiesPartialUpdateBodyClientIdMax).nullish(),
  "timeZone": zod.string().optional(),
  "buildingNumber": zod.string().max(propertiesPartialUpdateBodyBuildingNumberMax).optional(),
  "contact": zod.object({
  "name": zod.string().min(1).max(propertiesPartialUpdateBodyContactOneNameMax),
  "email": zod.string().email().nullish(),
  "phone": zod.string().nullish()
}).describe('A subclass of DRF\'s ModelSerializer which realizes when fields it is\nserializing are to related objects which also have NestableModelSerializers\ndefined for them and uses those serializers instead of the default\nModelSerializer that DRF would use.\n\nThis ModelSerializer takes an additional `fields` argument that\ncontrols which fields should be displayed.\nFor more information, refer to the documentation:\nhttps:\/\/www.django-rest-framework.org\/api-guide\/serializers\/#dynamically-modifying-fields\n\n\nExample:\nPortfolioSerializer(required=False, fields=[\"id\", \"name\"])').nullish()
}).describe('A subclass of DRF\'s ModelSerializer which realizes when fields it is\nserializing are to related objects which also have NestableModelSerializers\ndefined for them and uses those serializers instead of the default\nModelSerializer that DRF would use.\n\nThis ModelSerializer takes an additional `fields` argument that\ncontrols which fields should be displayed.\nFor more information, refer to the documentation:\nhttps:\/\/www.django-rest-framework.org\/api-guide\/serializers\/#dynamically-modifying-fields\n\n\nExample:\nPortfolioSerializer(required=False, fields=[\"id\", \"name\"])')

export const propertiesPartialUpdateResponseAddressOneRawMax = 200;

export const propertiesPartialUpdateResponseAddressOneFormattedMax = 200;

export const propertiesPartialUpdateResponseAddressOneStreetNumberMax = 20;

export const propertiesPartialUpdateResponseRegionMax = 255;

export const propertiesPartialUpdateResponseClientIdMax = 255;

export const propertiesPartialUpdateResponseLatDefault = 0;
export const propertiesPartialUpdateResponseLngDefault = 0;
export const propertiesPartialUpdateResponsePropertyManagerOneOwnerOneUsernameMax = 150;


export const propertiesPartialUpdateResponsePropertyManagerOneOwnerOneUsernameRegExp = new RegExp('^[\\w.@+-]+$');
export const propertiesPartialUpdateResponsePropertyManagerOneOwnerOneEmailMax = 254;

export const propertiesPartialUpdateResponsePropertyManagerOneOwnerOnePhoneNumberMax = 128;

export const propertiesPartialUpdateResponseConsultantGroupOneOwnerOneUsernameMax = 150;


export const propertiesPartialUpdateResponseConsultantGroupOneOwnerOneUsernameRegExp = new RegExp('^[\\w.@+-]+$');
export const propertiesPartialUpdateResponseConsultantGroupOneOwnerOneEmailMax = 254;

export const propertiesPartialUpdateResponseConsultantGroupOneOwnerOnePhoneNumberMax = 128;

export const propertiesPartialUpdateResponseConsultantGroupOneConsultantsItemUsernameMax = 150;


export const propertiesPartialUpdateResponseConsultantGroupOneConsultantsItemUsernameRegExp = new RegExp('^[\\w.@+-]+$');
export const propertiesPartialUpdateResponseConsultantGroupOneConsultantsItemEmailMax = 254;

export const propertiesPartialUpdateResponseConsultantGroupOneConsultantsItemPhoneNumberMax = 128;

export const propertiesPartialUpdateResponseConsultantGroupOneFileRegExp = new RegExp('(?:jpg|png|jpeg)$');
export const propertiesPartialUpdateResponseAssignedConsultantOneUsernameMax = 150;


export const propertiesPartialUpdateResponseAssignedConsultantOneUsernameRegExp = new RegExp('^[\\w.@+-]+$');
export const propertiesPartialUpdateResponseAssignedConsultantOneEmailMax = 254;

export const propertiesPartialUpdateResponseAssignedConsultantOnePhoneNumberMax = 128;

export const propertiesPartialUpdateResponseBuildingNumberMax = 255;

export const propertiesPartialUpdateResponseContactOneNameMax = 255;



export const PropertiesPartialUpdateResponse = zod.object({
  "id": zod.string().uuid(),
  "createdAt": zod.string().datetime({"offset":true}),
  "updatedAt": zod.string().datetime({"offset":true}).nullable(),
  "name": zod.string(),
  "address": zod.object({
  "id": zod.number(),
  "raw": zod.string().max(propertiesPartialUpdateResponseAddressOneRawMax),
  "formatted": zod.string().max(propertiesPartialUpdateResponseAddressOneFormattedMax).optional(),
  "streetNumber": zod.string().max(propertiesPartialUpdateResponseAddressOneStreetNumberMax).optional(),
  "street": zod.string(),
  "city": zod.string().nullable(),
  "postalCode": zod.string().nullable(),
  "state": zod.string().nullable(),
  "country": zod.string().nullable()
}).strict().nullable(),
  "region": zod.string().max(propertiesPartialUpdateResponseRegionMax).nullish(),
  "clientId": zod.string().max(propertiesPartialUpdateResponseClientIdMax).nullish(),
  "timeZone": zod.string().optional(),
  "lat": zod.number().nullable().default(propertiesPartialUpdateResponseLatDefault),
  "lng": zod.number().nullable().default(propertiesPartialUpdateResponseLngDefault),
  "propertyManager": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string(),
  "owner": zod.object({
  "id": zod.string().uuid(),
  "username": zod.string().max(propertiesPartialUpdateResponsePropertyManagerOneOwnerOneUsernameMax).regex(propertiesPartialUpdateResponsePropertyManagerOneOwnerOneUsernameRegExp).describe('Required. 150 characters or fewer. Letters, digits and @\/.\/+\/-\/_ only.'),
  "email": zod.string().email().max(propertiesPartialUpdateResponsePropertyManagerOneOwnerOneEmailMax).optional(),
  "phoneNumber": zod.string().max(propertiesPartialUpdateResponsePropertyManagerOneOwnerOnePhoneNumberMax).optional(),
  "fullName": zod.string(),
  "consultantGroup": zod.string().nullable(),
  "clientGroup": zod.string().nullable(),
  "role": zod.union([zod.enum(['consultant', 'client', 'service_provider']).describe('\* `consultant` - consultant\n\* `client` - client\n\* `service_provider` - service_provider'),zod.literal(null)]).nullable(),
  "isLiftaiAdmin": zod.boolean(),
  "isGroupAdmin": zod.boolean()
}).strict().nullable()
}).strict().nullable(),
  "consultantGroup": zod.object({
  "name": zod.string(),
  "id": zod.string().uuid(),
  "owner": zod.object({
  "id": zod.string().uuid(),
  "username": zod.string().max(propertiesPartialUpdateResponseConsultantGroupOneOwnerOneUsernameMax).regex(propertiesPartialUpdateResponseConsultantGroupOneOwnerOneUsernameRegExp).describe('Required. 150 characters or fewer. Letters, digits and @\/.\/+\/-\/_ only.'),
  "fullName": zod.string(),
  "email": zod.string().email().max(propertiesPartialUpdateResponseConsultantGroupOneOwnerOneEmailMax).optional(),
  "phoneNumber": zod.string().max(propertiesPartialUpdateResponseConsultantGroupOneOwnerOnePhoneNumberMax).optional()
}).strict().nullable(),
  "consultants": zod.array(zod.object({
  "id": zod.string().uuid(),
  "username": zod.string().max(propertiesPartialUpdateResponseConsultantGroupOneConsultantsItemUsernameMax).regex(propertiesPartialUpdateResponseConsultantGroupOneConsultantsItemUsernameRegExp).describe('Required. 150 characters or fewer. Letters, digits and @\/.\/+\/-\/_ only.'),
  "fullName": zod.string(),
  "email": zod.string().email().max(propertiesPartialUpdateResponseConsultantGroupOneConsultantsItemEmailMax).optional(),
  "phoneNumber": zod.string().max(propertiesPartialUpdateResponseConsultantGroupOneConsultantsItemPhoneNumberMax).optional()
}).strict()),
  "file": zod.string().url().regex(propertiesPartialUpdateResponseConsultantGroupOneFileRegExp).nullish()
}).strict().nullable(),
  "assignedConsultant": zod.object({
  "id": zod.string().uuid(),
  "username": zod.string().max(propertiesPartialUpdateResponseAssignedConsultantOneUsernameMax).regex(propertiesPartialUpdateResponseAssignedConsultantOneUsernameRegExp).describe('Required. 150 characters or fewer. Letters, digits and @\/.\/+\/-\/_ only.'),
  "email": zod.string().email().max(propertiesPartialUpdateResponseAssignedConsultantOneEmailMax).optional(),
  "phoneNumber": zod.string().max(propertiesPartialUpdateResponseAssignedConsultantOnePhoneNumberMax).optional(),
  "fullName": zod.string(),
  "consultantGroup": zod.string().nullable(),
  "clientGroup": zod.string().nullable(),
  "role": zod.union([zod.enum(['consultant', 'client', 'service_provider']).describe('\* `consultant` - consultant\n\* `client` - client\n\* `service_provider` - service_provider'),zod.literal(null)]).nullable(),
  "isLiftaiAdmin": zod.boolean(),
  "isGroupAdmin": zod.boolean()
}).strict().nullable(),
  "portfolio": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string()
}).strict().nullable(),
  "unitCount": zod.number(),
  "buildingNumber": zod.string().max(propertiesPartialUpdateResponseBuildingNumberMax).optional(),
  "contact": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string().max(propertiesPartialUpdateResponseContactOneNameMax),
  "email": zod.string().email().nullish(),
  "phone": zod.string().nullish(),
  "createdAt": zod.string().datetime({"offset":true}),
  "updatedAt": zod.string().datetime({"offset":true})
}).strict().nullish()
}).strict().describe('A subclass of DRF\'s ModelSerializer which realizes when fields it is\nserializing are to related objects which also have NestableModelSerializers\ndefined for them and uses those serializers instead of the default\nModelSerializer that DRF would use.\n\nThis ModelSerializer takes an additional `fields` argument that\ncontrols which fields should be displayed.\nFor more information, refer to the documentation:\nhttps:\/\/www.django-rest-framework.org\/api-guide\/serializers\/#dynamically-modifying-fields\n\n\nExample:\nPortfolioSerializer(required=False, fields=[\"id\", \"name\"])')

/**
 * Adds a GET-only ``aggregate`` action to a viewset.
 *
 * The viewset must declare ``AGGREGATE_CONFIG: AggregateConfig`` and a
 * ``filterset_class``. GET-only because the chat loopback only issues GET.
 */
export const PropertiesDestroyParams = zod.object({
  "id": zod.string().uuid().describe('A UUID string identifying this property.')
})

export const PropertiesDestroyResponse = zod.void()

/**
 * Basic API CRUD access to Property Contract entities.
 */
export const PropertiesContractsListParams = zod.object({
  "propertyPk": zod.string().uuid()
})

export const PropertiesContractsListQueryParams = zod.object({
  "limit": zod.number().optional().describe('Number of results to return per page.'),
  "offset": zod.number().optional().describe('The initial index from which to return the results.')
})

export const propertiesContractsListResponseResultsItemMonthlyPriceRegExp = new RegExp('^-?\\d{0,8}(?:\\.\\d{0,2})?$');
export const propertiesContractsListResponseResultsItemCarsItemMaintenanceQuantityRegExp = new RegExp('^-?\\d{0,2}(?:\\.\\d{0,2})?$');


export const PropertiesContractsListResponse = zod.object({
  "count": zod.number(),
  "next": zod.string().url().nullish(),
  "previous": zod.string().url().nullish(),
  "results": zod.array(zod.object({
  "id": zod.string().uuid().optional(),
  "propertyId": zod.string().uuid(),
  "contractId": zod.string().uuid(),
  "monthlyPrice": zod.string().regex(propertiesContractsListResponseResultsItemMonthlyPriceRegExp).nullable(),
  "rateSetId": zod.string().uuid().nullish(),
  "startDate": zod.string().date().nullish(),
  "expirationDate": zod.string().date().nullish(),
  "canChat": zod.boolean().describe('Determine if the contract has any PDF attachments with extractable text.\nUses the `can_chat` annotation from the queryset when available to avoid\nN+1 queries.'),
  "numCars": zod.number(),
  "cars": zod.array(zod.object({
  "id": zod.string().uuid().optional(),
  "carId": zod.string().uuid().optional(),
  "name": zod.string(),
  "ahjId": zod.string(),
  "elevatorType": zod.union([zod.enum(['Traction', 'Hydro', 'Other', 'escalator', 'hydraulic-passenger', 'hydraulic-service', 'mrl-traction', 'geared-passenger', 'geared-traction', 'gearless-traction', 'gearless-passenger', 'wheelchair-lift', 'dumbwaiter', 'passenger-service', 'high-rise-passenger', 'low-rise-passenger', 'passenger', 'freight']).describe('\* `Traction` - Traction\n\* `Hydro` - Hydro\n\* `Other` - Other\n\* `escalator` - Escalator\n\* `hydraulic-passenger` - Hydraulic Passenger\n\* `hydraulic-service` - Hydraulic Service\n\* `mrl-traction` - MRL Traction\n\* `geared-passenger` - Geared Passenger\n\* `geared-traction` - Geared Traction\n\* `gearless-traction` - Gearless Traction\n\* `gearless-passenger` - Gearless Passenger\n\* `wheelchair-lift` - Wheelchair Lift\n\* `dumbwaiter` - Dumbwaiter\n\* `passenger-service` - Passenger\/Service\n\* `high-rise-passenger` - High Rise Passenger\n\* `low-rise-passenger` - Low Rise Passenger\n\* `passenger` - Passenger\n\* `freight` - Freight'),zod.enum(['']),zod.literal(null)]).nullable(),
  "maintenanceQuantity": zod.string().regex(propertiesContractsListResponseResultsItemCarsItemMaintenanceQuantityRegExp),
  "maintenanceUnit": zod.string(),
  "maintenanceTimePeriod": zod.number(),
  "regularCallbackRate": zod.number(),
  "emergencyCallbackRate": zod.number(),
  "regularCallbackResponseTime": zod.number(),
  "emergencyCallbackResponseTime": zod.number()
}).strict()).optional()
}).strict())
}).strict()

/**
 * Basic API CRUD access to Property Contract entities.
 */
export const PropertiesContractsCreateParams = zod.object({
  "propertyPk": zod.string().uuid()
})

export const propertiesContractsCreateBodyMonthlyPriceRegExp = new RegExp('^-?\\d{0,8}(?:\\.\\d{0,2})?$');
export const propertiesContractsCreateBodyCarsItemMaintenanceQuantityRegExp = new RegExp('^-?\\d{0,2}(?:\\.\\d{0,2})?$');



export const PropertiesContractsCreateBody = zod.object({
  "id": zod.string().uuid().optional(),
  "propertyId": zod.string().uuid(),
  "monthlyPrice": zod.string().regex(propertiesContractsCreateBodyMonthlyPriceRegExp).nullable(),
  "rateSetId": zod.string().uuid().nullish(),
  "startDate": zod.string().date().nullish(),
  "expirationDate": zod.string().date().nullish(),
  "cars": zod.array(zod.object({
  "id": zod.string().uuid().optional(),
  "carId": zod.string().uuid().optional(),
  "maintenanceQuantity": zod.string().regex(propertiesContractsCreateBodyCarsItemMaintenanceQuantityRegExp),
  "maintenanceUnit": zod.string().min(1),
  "maintenanceTimePeriod": zod.number(),
  "regularCallbackRate": zod.number(),
  "emergencyCallbackRate": zod.number(),
  "regularCallbackResponseTime": zod.number(),
  "emergencyCallbackResponseTime": zod.number()
})).optional()
})

export const propertiesContractsCreateResponseMonthlyPriceRegExp = new RegExp('^-?\\d{0,8}(?:\\.\\d{0,2})?$');
export const propertiesContractsCreateResponseCarsItemMaintenanceQuantityRegExp = new RegExp('^-?\\d{0,2}(?:\\.\\d{0,2})?$');


export const PropertiesContractsCreateResponse = zod.object({
  "id": zod.string().uuid().optional(),
  "propertyId": zod.string().uuid(),
  "contractId": zod.string().uuid(),
  "monthlyPrice": zod.string().regex(propertiesContractsCreateResponseMonthlyPriceRegExp).nullable(),
  "rateSetId": zod.string().uuid().nullish(),
  "startDate": zod.string().date().nullish(),
  "expirationDate": zod.string().date().nullish(),
  "canChat": zod.boolean().describe('Determine if the contract has any PDF attachments with extractable text.\nUses the `can_chat` annotation from the queryset when available to avoid\nN+1 queries.'),
  "numCars": zod.number(),
  "cars": zod.array(zod.object({
  "id": zod.string().uuid().optional(),
  "carId": zod.string().uuid().optional(),
  "name": zod.string(),
  "ahjId": zod.string(),
  "elevatorType": zod.union([zod.enum(['Traction', 'Hydro', 'Other', 'escalator', 'hydraulic-passenger', 'hydraulic-service', 'mrl-traction', 'geared-passenger', 'geared-traction', 'gearless-traction', 'gearless-passenger', 'wheelchair-lift', 'dumbwaiter', 'passenger-service', 'high-rise-passenger', 'low-rise-passenger', 'passenger', 'freight']).describe('\* `Traction` - Traction\n\* `Hydro` - Hydro\n\* `Other` - Other\n\* `escalator` - Escalator\n\* `hydraulic-passenger` - Hydraulic Passenger\n\* `hydraulic-service` - Hydraulic Service\n\* `mrl-traction` - MRL Traction\n\* `geared-passenger` - Geared Passenger\n\* `geared-traction` - Geared Traction\n\* `gearless-traction` - Gearless Traction\n\* `gearless-passenger` - Gearless Passenger\n\* `wheelchair-lift` - Wheelchair Lift\n\* `dumbwaiter` - Dumbwaiter\n\* `passenger-service` - Passenger\/Service\n\* `high-rise-passenger` - High Rise Passenger\n\* `low-rise-passenger` - Low Rise Passenger\n\* `passenger` - Passenger\n\* `freight` - Freight'),zod.enum(['']),zod.literal(null)]).nullable(),
  "maintenanceQuantity": zod.string().regex(propertiesContractsCreateResponseCarsItemMaintenanceQuantityRegExp),
  "maintenanceUnit": zod.string(),
  "maintenanceTimePeriod": zod.number(),
  "regularCallbackRate": zod.number(),
  "emergencyCallbackRate": zod.number(),
  "regularCallbackResponseTime": zod.number(),
  "emergencyCallbackResponseTime": zod.number()
}).strict()).optional()
}).strict()

/**
 * Basic API CRUD access to Property Contract entities.
 */
export const PropertiesContractsRetrieveParams = zod.object({
  "id": zod.string().uuid().describe('A UUID string identifying this Property Contract.'),
  "propertyPk": zod.string().uuid()
})

export const propertiesContractsRetrieveResponseMonthlyPriceRegExp = new RegExp('^-?\\d{0,8}(?:\\.\\d{0,2})?$');
export const propertiesContractsRetrieveResponseCarsItemMaintenanceQuantityRegExp = new RegExp('^-?\\d{0,2}(?:\\.\\d{0,2})?$');


export const PropertiesContractsRetrieveResponse = zod.object({
  "id": zod.string().uuid().optional(),
  "propertyId": zod.string().uuid(),
  "contractId": zod.string().uuid(),
  "monthlyPrice": zod.string().regex(propertiesContractsRetrieveResponseMonthlyPriceRegExp).nullable(),
  "rateSetId": zod.string().uuid().nullish(),
  "startDate": zod.string().date().nullish(),
  "expirationDate": zod.string().date().nullish(),
  "canChat": zod.boolean().describe('Determine if the contract has any PDF attachments with extractable text.\nUses the `can_chat` annotation from the queryset when available to avoid\nN+1 queries.'),
  "numCars": zod.number(),
  "cars": zod.array(zod.object({
  "id": zod.string().uuid().optional(),
  "carId": zod.string().uuid().optional(),
  "name": zod.string(),
  "ahjId": zod.string(),
  "elevatorType": zod.union([zod.enum(['Traction', 'Hydro', 'Other', 'escalator', 'hydraulic-passenger', 'hydraulic-service', 'mrl-traction', 'geared-passenger', 'geared-traction', 'gearless-traction', 'gearless-passenger', 'wheelchair-lift', 'dumbwaiter', 'passenger-service', 'high-rise-passenger', 'low-rise-passenger', 'passenger', 'freight']).describe('\* `Traction` - Traction\n\* `Hydro` - Hydro\n\* `Other` - Other\n\* `escalator` - Escalator\n\* `hydraulic-passenger` - Hydraulic Passenger\n\* `hydraulic-service` - Hydraulic Service\n\* `mrl-traction` - MRL Traction\n\* `geared-passenger` - Geared Passenger\n\* `geared-traction` - Geared Traction\n\* `gearless-traction` - Gearless Traction\n\* `gearless-passenger` - Gearless Passenger\n\* `wheelchair-lift` - Wheelchair Lift\n\* `dumbwaiter` - Dumbwaiter\n\* `passenger-service` - Passenger\/Service\n\* `high-rise-passenger` - High Rise Passenger\n\* `low-rise-passenger` - Low Rise Passenger\n\* `passenger` - Passenger\n\* `freight` - Freight'),zod.enum(['']),zod.literal(null)]).nullable(),
  "maintenanceQuantity": zod.string().regex(propertiesContractsRetrieveResponseCarsItemMaintenanceQuantityRegExp),
  "maintenanceUnit": zod.string(),
  "maintenanceTimePeriod": zod.number(),
  "regularCallbackRate": zod.number(),
  "emergencyCallbackRate": zod.number(),
  "regularCallbackResponseTime": zod.number(),
  "emergencyCallbackResponseTime": zod.number()
}).strict()).optional()
}).strict()

/**
 * Basic API CRUD access to Property Contract entities.
 */
export const PropertiesContractsUpdateParams = zod.object({
  "id": zod.string().uuid().describe('A UUID string identifying this Property Contract.'),
  "propertyPk": zod.string().uuid()
})

export const propertiesContractsUpdateBodyMonthlyPriceRegExp = new RegExp('^-?\\d{0,8}(?:\\.\\d{0,2})?$');
export const propertiesContractsUpdateBodyCarsItemMaintenanceQuantityRegExp = new RegExp('^-?\\d{0,2}(?:\\.\\d{0,2})?$');



export const PropertiesContractsUpdateBody = zod.object({
  "id": zod.string().uuid().optional(),
  "propertyId": zod.string().uuid(),
  "monthlyPrice": zod.string().regex(propertiesContractsUpdateBodyMonthlyPriceRegExp).nullable(),
  "rateSetId": zod.string().uuid().nullish(),
  "startDate": zod.string().date().nullish(),
  "expirationDate": zod.string().date().nullish(),
  "cars": zod.array(zod.object({
  "id": zod.string().uuid().optional(),
  "carId": zod.string().uuid().optional(),
  "maintenanceQuantity": zod.string().regex(propertiesContractsUpdateBodyCarsItemMaintenanceQuantityRegExp),
  "maintenanceUnit": zod.string().min(1),
  "maintenanceTimePeriod": zod.number(),
  "regularCallbackRate": zod.number(),
  "emergencyCallbackRate": zod.number(),
  "regularCallbackResponseTime": zod.number(),
  "emergencyCallbackResponseTime": zod.number()
})).optional()
})

export const propertiesContractsUpdateResponseMonthlyPriceRegExp = new RegExp('^-?\\d{0,8}(?:\\.\\d{0,2})?$');
export const propertiesContractsUpdateResponseCarsItemMaintenanceQuantityRegExp = new RegExp('^-?\\d{0,2}(?:\\.\\d{0,2})?$');


export const PropertiesContractsUpdateResponse = zod.object({
  "id": zod.string().uuid().optional(),
  "propertyId": zod.string().uuid(),
  "contractId": zod.string().uuid(),
  "monthlyPrice": zod.string().regex(propertiesContractsUpdateResponseMonthlyPriceRegExp).nullable(),
  "rateSetId": zod.string().uuid().nullish(),
  "startDate": zod.string().date().nullish(),
  "expirationDate": zod.string().date().nullish(),
  "canChat": zod.boolean().describe('Determine if the contract has any PDF attachments with extractable text.\nUses the `can_chat` annotation from the queryset when available to avoid\nN+1 queries.'),
  "numCars": zod.number(),
  "cars": zod.array(zod.object({
  "id": zod.string().uuid().optional(),
  "carId": zod.string().uuid().optional(),
  "name": zod.string(),
  "ahjId": zod.string(),
  "elevatorType": zod.union([zod.enum(['Traction', 'Hydro', 'Other', 'escalator', 'hydraulic-passenger', 'hydraulic-service', 'mrl-traction', 'geared-passenger', 'geared-traction', 'gearless-traction', 'gearless-passenger', 'wheelchair-lift', 'dumbwaiter', 'passenger-service', 'high-rise-passenger', 'low-rise-passenger', 'passenger', 'freight']).describe('\* `Traction` - Traction\n\* `Hydro` - Hydro\n\* `Other` - Other\n\* `escalator` - Escalator\n\* `hydraulic-passenger` - Hydraulic Passenger\n\* `hydraulic-service` - Hydraulic Service\n\* `mrl-traction` - MRL Traction\n\* `geared-passenger` - Geared Passenger\n\* `geared-traction` - Geared Traction\n\* `gearless-traction` - Gearless Traction\n\* `gearless-passenger` - Gearless Passenger\n\* `wheelchair-lift` - Wheelchair Lift\n\* `dumbwaiter` - Dumbwaiter\n\* `passenger-service` - Passenger\/Service\n\* `high-rise-passenger` - High Rise Passenger\n\* `low-rise-passenger` - Low Rise Passenger\n\* `passenger` - Passenger\n\* `freight` - Freight'),zod.enum(['']),zod.literal(null)]).nullable(),
  "maintenanceQuantity": zod.string().regex(propertiesContractsUpdateResponseCarsItemMaintenanceQuantityRegExp),
  "maintenanceUnit": zod.string(),
  "maintenanceTimePeriod": zod.number(),
  "regularCallbackRate": zod.number(),
  "emergencyCallbackRate": zod.number(),
  "regularCallbackResponseTime": zod.number(),
  "emergencyCallbackResponseTime": zod.number()
}).strict()).optional()
}).strict()

/**
 * Basic API CRUD access to Property Contract entities.
 */
export const PropertiesContractsPartialUpdateParams = zod.object({
  "id": zod.string().uuid().describe('A UUID string identifying this Property Contract.'),
  "propertyPk": zod.string().uuid()
})

export const propertiesContractsPartialUpdateBodyMonthlyPriceRegExp = new RegExp('^-?\\d{0,8}(?:\\.\\d{0,2})?$');
export const propertiesContractsPartialUpdateBodyCarsItemMaintenanceQuantityRegExp = new RegExp('^-?\\d{0,2}(?:\\.\\d{0,2})?$');



export const PropertiesContractsPartialUpdateBody = zod.object({
  "id": zod.string().uuid().optional(),
  "propertyId": zod.string().uuid().optional(),
  "monthlyPrice": zod.string().regex(propertiesContractsPartialUpdateBodyMonthlyPriceRegExp).nullish(),
  "rateSetId": zod.string().uuid().nullish(),
  "startDate": zod.string().date().nullish(),
  "expirationDate": zod.string().date().nullish(),
  "cars": zod.array(zod.object({
  "id": zod.string().uuid().optional(),
  "carId": zod.string().uuid().optional(),
  "maintenanceQuantity": zod.string().regex(propertiesContractsPartialUpdateBodyCarsItemMaintenanceQuantityRegExp),
  "maintenanceUnit": zod.string().min(1),
  "maintenanceTimePeriod": zod.number(),
  "regularCallbackRate": zod.number(),
  "emergencyCallbackRate": zod.number(),
  "regularCallbackResponseTime": zod.number(),
  "emergencyCallbackResponseTime": zod.number()
})).optional()
})

export const propertiesContractsPartialUpdateResponseMonthlyPriceRegExp = new RegExp('^-?\\d{0,8}(?:\\.\\d{0,2})?$');
export const propertiesContractsPartialUpdateResponseCarsItemMaintenanceQuantityRegExp = new RegExp('^-?\\d{0,2}(?:\\.\\d{0,2})?$');


export const PropertiesContractsPartialUpdateResponse = zod.object({
  "id": zod.string().uuid().optional(),
  "propertyId": zod.string().uuid(),
  "contractId": zod.string().uuid(),
  "monthlyPrice": zod.string().regex(propertiesContractsPartialUpdateResponseMonthlyPriceRegExp).nullable(),
  "rateSetId": zod.string().uuid().nullish(),
  "startDate": zod.string().date().nullish(),
  "expirationDate": zod.string().date().nullish(),
  "canChat": zod.boolean().describe('Determine if the contract has any PDF attachments with extractable text.\nUses the `can_chat` annotation from the queryset when available to avoid\nN+1 queries.'),
  "numCars": zod.number(),
  "cars": zod.array(zod.object({
  "id": zod.string().uuid().optional(),
  "carId": zod.string().uuid().optional(),
  "name": zod.string(),
  "ahjId": zod.string(),
  "elevatorType": zod.union([zod.enum(['Traction', 'Hydro', 'Other', 'escalator', 'hydraulic-passenger', 'hydraulic-service', 'mrl-traction', 'geared-passenger', 'geared-traction', 'gearless-traction', 'gearless-passenger', 'wheelchair-lift', 'dumbwaiter', 'passenger-service', 'high-rise-passenger', 'low-rise-passenger', 'passenger', 'freight']).describe('\* `Traction` - Traction\n\* `Hydro` - Hydro\n\* `Other` - Other\n\* `escalator` - Escalator\n\* `hydraulic-passenger` - Hydraulic Passenger\n\* `hydraulic-service` - Hydraulic Service\n\* `mrl-traction` - MRL Traction\n\* `geared-passenger` - Geared Passenger\n\* `geared-traction` - Geared Traction\n\* `gearless-traction` - Gearless Traction\n\* `gearless-passenger` - Gearless Passenger\n\* `wheelchair-lift` - Wheelchair Lift\n\* `dumbwaiter` - Dumbwaiter\n\* `passenger-service` - Passenger\/Service\n\* `high-rise-passenger` - High Rise Passenger\n\* `low-rise-passenger` - Low Rise Passenger\n\* `passenger` - Passenger\n\* `freight` - Freight'),zod.enum(['']),zod.literal(null)]).nullable(),
  "maintenanceQuantity": zod.string().regex(propertiesContractsPartialUpdateResponseCarsItemMaintenanceQuantityRegExp),
  "maintenanceUnit": zod.string(),
  "maintenanceTimePeriod": zod.number(),
  "regularCallbackRate": zod.number(),
  "emergencyCallbackRate": zod.number(),
  "regularCallbackResponseTime": zod.number(),
  "emergencyCallbackResponseTime": zod.number()
}).strict()).optional()
}).strict()

/**
 * Basic API CRUD access to Property Contract entities.
 */
export const PropertiesContractsDestroyParams = zod.object({
  "id": zod.string().uuid().describe('A UUID string identifying this Property Contract.'),
  "propertyPk": zod.string().uuid()
})

export const PropertiesContractsDestroyResponse = zod.void()

/**
 * A property's knowledge: its own entries and every one of its cars'.
 */
export const PropertiesKnowledgeListParams = zod.object({
  "propertyPk": zod.string().uuid().describe('UUID of the parent property.')
})

export const PropertiesKnowledgeListQueryParams = zod.object({
  "q": zod.string().optional().describe('Full-text search over entry content, best match first. Falls back to a substring match when full-text search finds nothing.')
})

export const PropertiesKnowledgeListResponseItem = zod.object({
  "id": zod.string().uuid(),
  "propertyId": zod.string().uuid(),
  "carId": zod.string().uuid().nullable(),
  "kind": zod.enum(['note', 'decision', 'commitment']).describe('\* `note` - Note\n\* `decision` - Decision\n\* `commitment` - Commitment'),
  "content": zod.string(),
  "source": zod.enum(['manual', 'assistant', 'task']).describe('\* `manual` - Manual\n\* `assistant` - Assistant\n\* `task` - Task'),
  "author": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string()
}).strict().nullable(),
  "isAuthor": zod.boolean(),
  "task": zod.object({
  "id": zod.string().uuid(),
  "displayId": zod.string()
}).strict().nullable(),
  "supersedesId": zod.string().uuid().nullable(),
  "supersededById": zod.string().uuid().nullable(),
  "createdAt": zod.string().datetime({"offset":true}),
  "updatedAt": zod.string().datetime({"offset":true}).nullable()
}).strict()
export const PropertiesKnowledgeListResponse = zod.array(PropertiesKnowledgeListResponseItem)

/**
 * A property's knowledge: its own entries and every one of its cars'.
 */
export const PropertiesKnowledgeCreateParams = zod.object({
  "propertyPk": zod.string().uuid().describe('UUID of the parent property.')
})

export const propertiesKnowledgeCreateBodyContentMax = 4000;



export const PropertiesKnowledgeCreateBody = zod.object({
  "carId": zod.string().uuid().nullish(),
  "kind": zod.enum(['note', 'decision', 'commitment']).optional().describe('\* `note` - Note\n\* `decision` - Decision\n\* `commitment` - Commitment'),
  "content": zod.string().min(1).max(propertiesKnowledgeCreateBodyContentMax),
  "source": zod.enum(['manual', 'assistant']).optional().describe('\* `manual` - manual\n\* `assistant` - assistant'),
  "supersedesId": zod.string().uuid().nullish(),
  "followUpDate": zod.string().date().nullish()
}).describe('``car_id``, if given, must be a car on the property in the URL.')

export const PropertiesKnowledgeCreateResponse = zod.object({
  "id": zod.string().uuid(),
  "propertyId": zod.string().uuid(),
  "carId": zod.string().uuid().nullable(),
  "kind": zod.enum(['note', 'decision', 'commitment']).describe('\* `note` - Note\n\* `decision` - Decision\n\* `commitment` - Commitment'),
  "content": zod.string(),
  "source": zod.enum(['manual', 'assistant', 'task']).describe('\* `manual` - Manual\n\* `assistant` - Assistant\n\* `task` - Task'),
  "author": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string()
}).strict().nullable(),
  "isAuthor": zod.boolean(),
  "task": zod.object({
  "id": zod.string().uuid(),
  "displayId": zod.string()
}).strict().nullable(),
  "supersedesId": zod.string().uuid().nullable(),
  "supersededById": zod.string().uuid().nullable(),
  "createdAt": zod.string().datetime({"offset":true}),
  "updatedAt": zod.string().datetime({"offset":true}).nullable(),
  "followUpTask": zod.object({
  "id": zod.string().uuid(),
  "displayId": zod.string()
}).strict().nullable()
}).strict().describe('A new entry, plus the follow-up task its commitment opened, if any.')

/**
 * A property's knowledge: its own entries and every one of its cars'.
 */
export const PropertiesKnowledgeRetrieveParams = zod.object({
  "id": zod.string().uuid().describe('A UUID string identifying this knowledge entry.'),
  "propertyPk": zod.string().uuid().describe('UUID of the parent property.')
})

export const PropertiesKnowledgeRetrieveResponse = zod.object({
  "id": zod.string().uuid(),
  "propertyId": zod.string().uuid(),
  "carId": zod.string().uuid().nullable(),
  "kind": zod.enum(['note', 'decision', 'commitment']).describe('\* `note` - Note\n\* `decision` - Decision\n\* `commitment` - Commitment'),
  "content": zod.string(),
  "source": zod.enum(['manual', 'assistant', 'task']).describe('\* `manual` - Manual\n\* `assistant` - Assistant\n\* `task` - Task'),
  "author": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string()
}).strict().nullable(),
  "isAuthor": zod.boolean(),
  "task": zod.object({
  "id": zod.string().uuid(),
  "displayId": zod.string()
}).strict().nullable(),
  "supersedesId": zod.string().uuid().nullable(),
  "supersededById": zod.string().uuid().nullable(),
  "createdAt": zod.string().datetime({"offset":true}),
  "updatedAt": zod.string().datetime({"offset":true}).nullable()
}).strict()

/**
 * A property's knowledge: its own entries and every one of its cars'.
 */
export const PropertiesKnowledgePartialUpdateParams = zod.object({
  "id": zod.string().uuid().describe('A UUID string identifying this knowledge entry.'),
  "propertyPk": zod.string().uuid().describe('UUID of the parent property.')
})

export const propertiesKnowledgePartialUpdateBodyContentMax = 4000;



export const PropertiesKnowledgePartialUpdateBody = zod.object({
  "kind": zod.enum(['note', 'decision', 'commitment']).optional().describe('\* `note` - Note\n\* `decision` - Decision\n\* `commitment` - Commitment'),
  "content": zod.string().min(1).max(propertiesKnowledgePartialUpdateBodyContentMax).optional()
}).describe('Only the text and kind can change.')

export const PropertiesKnowledgePartialUpdateResponse = zod.object({
  "id": zod.string().uuid(),
  "propertyId": zod.string().uuid(),
  "carId": zod.string().uuid().nullable(),
  "kind": zod.enum(['note', 'decision', 'commitment']).describe('\* `note` - Note\n\* `decision` - Decision\n\* `commitment` - Commitment'),
  "content": zod.string(),
  "source": zod.enum(['manual', 'assistant', 'task']).describe('\* `manual` - Manual\n\* `assistant` - Assistant\n\* `task` - Task'),
  "author": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string()
}).strict().nullable(),
  "isAuthor": zod.boolean(),
  "task": zod.object({
  "id": zod.string().uuid(),
  "displayId": zod.string()
}).strict().nullable(),
  "supersedesId": zod.string().uuid().nullable(),
  "supersededById": zod.string().uuid().nullable(),
  "createdAt": zod.string().datetime({"offset":true}),
  "updatedAt": zod.string().datetime({"offset":true}).nullable()
}).strict()

/**
 * A property's knowledge: its own entries and every one of its cars'.
 */
export const PropertiesKnowledgeDestroyParams = zod.object({
  "id": zod.string().uuid().describe('A UUID string identifying this knowledge entry.'),
  "propertyPk": zod.string().uuid().describe('UUID of the parent property.')
})

export const PropertiesKnowledgeDestroyResponse = zod.void()

/**
 * Makes a replaced entry current again.
 */
export const PropertiesKnowledgeRestoreParams = zod.object({
  "id": zod.string().uuid().describe('UUID of the replaced entry.'),
  "propertyPk": zod.string().uuid().describe('UUID of the parent property.')
})

export const PropertiesKnowledgeRestoreResponse = zod.object({
  "id": zod.string().uuid(),
  "propertyId": zod.string().uuid(),
  "carId": zod.string().uuid().nullable(),
  "kind": zod.enum(['note', 'decision', 'commitment']).describe('\* `note` - Note\n\* `decision` - Decision\n\* `commitment` - Commitment'),
  "content": zod.string(),
  "source": zod.enum(['manual', 'assistant', 'task']).describe('\* `manual` - Manual\n\* `assistant` - Assistant\n\* `task` - Task'),
  "author": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string()
}).strict().nullable(),
  "isAuthor": zod.boolean(),
  "task": zod.object({
  "id": zod.string().uuid(),
  "displayId": zod.string()
}).strict().nullable(),
  "supersedesId": zod.string().uuid().nullable(),
  "supersededById": zod.string().uuid().nullable(),
  "createdAt": zod.string().datetime({"offset":true}),
  "updatedAt": zod.string().datetime({"offset":true}).nullable()
}).strict()

/**
 * Adds a GET-only ``aggregate`` action to a viewset.
 *
 * The viewset must declare ``AGGREGATE_CONFIG: AggregateConfig`` and a
 * ``filterset_class``. GET-only because the chat loopback only issues GET.
 */
export const PropertiesAggregateRetrieveQueryParams = zod.object({
  "date_after": zod.string().date().optional().describe('Explicit start of the date range (inclusive).'),
  "date_before": zod.string().date().optional().describe('Explicit end of the date range (inclusive).'),
  "group_by": zod.string().optional().describe('Optional whitelisted group-by dimension (entity-specific, e.g. ``property``, ``portfolio``, ``entry_type``). Omit for a single scalar value; an unknown value returns 400 listing the valid dimensions.'),
  "limit": zod.number().optional().describe('Top-N rows for a grouped result, clamped to [1, 50]. Ignored for scalar results.'),
  "metric": zod.string().describe('Whitelisted metric to compute (entity-specific, e.g. ``invoice_amount``, ``ticket_count``, ``unit_count``). An unknown value returns 400 listing the entity\'s valid metrics.'),
  "period": zod.string().optional().describe('Named relative date range (one of ``30d``\/``90d``\/``ytd``\/``ttm``\/``all``\/``custom``) resolved into the entity\'s date filter. ``all`` applies no date bound at all. Routed to ``dropped_filters`` for entities without a date filter.')
})

export const PropertiesAggregateRetrieveResponse = zod.union([zod.object({
  "entity": zod.string(),
  "metric": zod.string(),
  "value": zod.number().nullable(),
  "filtersApplied": zod.record(zod.string(), zod.unknown()),
  "droppedFilters": zod.record(zod.string(), zod.unknown())
}).strict().describe('Ungrouped aggregate: a single scalar ``value`` for the whole scope.'),zod.object({
  "entity": zod.string(),
  "metric": zod.string(),
  "groupBy": zod.string(),
  "rows": zod.array(zod.object({
  "group": zod.string().nullable(),
  "value": zod.number().nullable()
}).strict().describe('One row of a grouped aggregate: a display label and its metric value.')),
  "total": zod.number().nullable(),
  "groupCount": zod.number(),
  "shown": zod.number(),
  "truncated": zod.boolean(),
  "filtersApplied": zod.record(zod.string(), zod.unknown()),
  "droppedFilters": zod.record(zod.string(), zod.unknown())
}).strict().describe('Grouped aggregate: top-N rows plus the grand total and group count.')])

/**
 * Trimmed {id, name} property list for form dropdowns.
 *
 * Separate endpoint (SDK: propertiesFormList) so the generated type is the
 * precise PropertyForm shape rather than the full PropertySerializer — the
 * old ``?variant=form`` query param can't be typed per-value in OpenAPI.
 */
export const PropertiesFormListQueryParams = zod.object({
  "address": zod.string().optional(),
  "client_id": zod.string().optional(),
  "ordering": zod.array(zod.enum(['-name', 'name'])).optional().describe('Ordering\n\n\* `name` - Name\n\* `-name` - Name (descending)'),
  "portfolio": zod.array(zod.string().uuid()).optional(),
  "query": zod.string().optional(),
  "region": zod.array(zod.string().nullable()).optional()
})

export const PropertiesFormListResponseItem = zod.object({
  "id": zod.string().uuid(),
  "name": zod.string()
}).strict().describe('A subclass of DRF\'s ModelSerializer which realizes when fields it is\nserializing are to related objects which also have NestableModelSerializers\ndefined for them and uses those serializers instead of the default\nModelSerializer that DRF would use.\n\nThis ModelSerializer takes an additional `fields` argument that\ncontrols which fields should be displayed.\nFor more information, refer to the documentation:\nhttps:\/\/www.django-rest-framework.org\/api-guide\/serializers\/#dynamically-modifying-fields\n\n\nExample:\nPortfolioSerializer(required=False, fields=[\"id\", \"name\"])')
export const PropertiesFormListResponse = zod.array(PropertiesFormListResponseItem)

